const toPositiveInteger = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const getCropDurationDays = (crop) => {
  const savedDuration = toPositiveInteger(crop?.days);
  if (savedDuration !== null) return savedDuration;

  const periods = [crop?.init, crop?.dev, crop?.mid, crop?.late].map(
    toPositiveInteger
  );
  if (periods.every((period) => period !== null)) {
    return periods.reduce((total, period) => total + period, 0);
  }

  return toPositiveInteger(crop?.croptype?.total);
};

export const getCropEndDate = (crop) => {
  const startDate = new Date(crop?.growingDate);
  const durationDays = getCropDurationDays(crop);

  if (Number.isNaN(startDate.getTime()) || durationDays === null) return null;

  const endDate = new Date(startDate);
  endDate.setUTCDate(endDate.getUTCDate() + durationDays);
  return endDate;
};
